import dayjs from "dayjs"
import React, { useState } from "react"
import { MdPowerSettingsNew } from "react-icons/md"
// import Icon from "react-native-vector-icons/MaterialIcons"
import backImage from "../assets/drMakhwanya.png"
import { auth } from "../firebase"
import { useGetQueue, useMyAppointments } from "../functions/queue"
import CompanyInfo from "./CompanyInfo"
import SymptomForm from "./SymptomForm"

const width = window.innerWidth
const height = window.innerHeight

const styles = {
    container: {
        width,
        height,
    },
    backWrapper: {
        position: "absolute",
        top: 0,
        width,
        height,
        backgroundColor: "rgba(25,0,0,0.7)"
    },
    headText: {
        fontSize: 35,
        fontWeight: "bold",
        textAlign: "center",
        color: "white"
    },
    subTexts: {
        fontSize: 17,
        textAlign: "center",
        color: "white",
        fontWeight: "bold"
    },
    titlesWrapper: {
        marginVertical: 20,
        marginBottom: 25
    },
    articleTitle: {
        margin: "0 15px",
        fontSize: 20,
        color: "#fff",
        fontWeight: "bold",
        textAlign: "center"
    },
    menuButton: {
        width: 60,
        height: 60,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        alignSelf: "flex-start"
    },
    buttons: {
        position: "absolute",
        bottom: 80,
        width,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column"
    },
    buttonWrapper: {
        // height: 50,
        padding: "15px 0",
        width: width - 40,
        borderRadius: 50,
        backgroundColor: "white",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        margin: 10,
        marginTop: 5,
        alignSelf: "center"
    },
    buttonText: {
        color: "red",
        fontSize: 16,
        fontWeight: "bold"
    },
    queueWrapper: {
        width: 200,
        height: 200,
        backgroundColor: "red",
        borderRadius: 100,
        display: "flex",
        alignSelf: "center",
        justifyContent: "center",
        alignItems: "center",
        margin: "20px auto 0 auto",
        borderWidth: 10,
        borderColor: "white",
        borderTopColor: "transparent"
    },
    queueNumber: {
        fontSize: 40,
        color: "white",
        fontWeight: "bold"
    }
}

export default function Home({ navigation }) {

    const [menu, setMenu] = useState(false)
    const [appointment, setAppointment] = useState(false)
    const [loading, setLoading] = useState(false)

    const signOut = async () => {
        setLoading(true)
        await auth.signOut()
        setLoading(false)
    }

    const today = dayjs(new Date()).format("YYYY-MM-DD")
    const [date, setDate] = useState(dayjs(new Date()).format("YYYY-MM-DD"))

    const [queue] = useGetQueue(date) 
    const { onQueue } = useMyAppointments(date)

    const peopleAhead = queue?.line - (onQueue[0]?.queuedAt || 0)
    const queueStatus = queue?.line - queue?.queueAt < 0 ? 0 : `${queue?.queueAt}/${queue?.line}`
    const status = today !== date ? "..." : (!onQueue[0] ? queueStatus : (peopleAhead === 1 ? "Next" : peopleAhead === 0 ? "Go In" : peopleAhead < 0 ? "Missed" : `${peopleAhead} Left`))

    return (
        <>
            <img src={backImage} style={{ width, height, position: "absolute", top: 0, objectFit: "cover" }} alt="background" />
            <div style={styles.backWrapper} />
            <div style={{ width, height }}>
                <div style={{ ...styles.container, position: "fixed", top: 0 }}>
                    <div style={{ alignSelf: "flex-end", display: "flex", margin: "0 0 0 auto" }}>
                        <div onClick={signOut} style={styles.menuButton}>
                            <MdPowerSettingsNew name="power-settings-new" size={30} color="#fff" />
                        </div>
                    </div>

                    <div style={styles.titlesWrapper}>
                        <br/>
                        <p style={styles.headText}>Dr Makhwanya</p>
                        <p style={styles.headText}>Private Practice</p>
                        <p style={styles.subTexts}>MBCHB - MP 0607002</p>
                    </div>
                    <p style={styles.articleTitle}>
                        {dayjs(date).format("MMMM DD, YYYY")}
                    </p>
                    <div style={styles.queueWrapper}>
                        <p style={styles.queueNumber}>{status}</p>
                    </div>
                    <div style={styles.buttons}>
                        {onQueue.length > 0 && 
                            <div onClick={() => navigation.navigate("appointment")} style={styles.buttonWrapper}>
                            <p style={styles.buttonText}>
                                Open Appointments
                            </p>
                        </div>}
                        <div onClick={setAppointment} style={{ ...styles.buttonWrapper, backgroundColor: "#F00"}}>
                            <p style={{ ...styles.buttonText, color: "#FFF" }}>
                                {onQueue.length === 0 ? "Book Appointment" : "Make Another Appointment"} 
                            </p>
                        </div>
                    </div>

                </div>
                <CompanyInfo {...{ menu, setMenu, navigation }} />
                <SymptomForm {...{ appointment, setAppointment, navigation, setDate }} />
            </div>
        </>
    )
}